import {EnergieEnum} from '../enums/EnergieEnum';

export class Energie {
  type: EnergieEnum;
  color: string;
  unite: string;

  constructor(type: EnergieEnum, color: string, unite: string) {
    this.type = type;
    this.color = color;
    this.unite = unite;
  }
}
